export default __webpack_public_path__ + "static/mptc-53e284c6ec186ccca7cee444c67b5ac8.svg";